import {Images} from "utils";
import React from "react";
import {buttonsStyle} from "./styles";

export const EditIcon =({handleClick, styles})=>{
    const classes = buttonsStyle()
    return(
        <button
            style={{...styles}}
            onClick={handleClick}
            className={classes.editButton}>
            <img src={Images.edit} alt={'icon'}/>
            <span>Edit</span>
        </button>
    )
}